import React from 'react';

function WhatIsOsap() {
    return (
        <section className="information" id="when-to-apply">
            <div className="content">
                <h2>When to apply</h2>
                <p>
                    The Ontario Student Assistance Program <span className="osap-highlight">OSAP</span> helps students fund their postsecondary education, but timing your application is key to ensuring timely financial support.
                </p>
                <ul>
                    <li>
                        <span style={{ fontWeight: 700 }}>For full-time students,</span>{' '}
                        <span className="osap-highlight">OSAP</span> applications typically open in the spring, around May, for the upcoming academic year starting in September. It’s best to apply as early as possible—at least 60 days before your program begins—to allow time for processing and avoid delays in receiving funds.
                    </li>
                    <li>
                        <span style={{ fontWeight: 700 }}>Part-time students</span> can also apply in the spring, with similar deadlines, though funding amounts may differ based on course load.
                    </li>
                    <li>
                        <span style={{ fontWeight: 700 }}>Micro-credential programs</span> often have rolling application periods, so check specific program dates.
                    </li>
                </ul>
                <p>
                    Missing deadlines can delay your funding, impacting your ability to cover tuition, books, and living expenses. To stay on track, gather required documents like income information and program details early, and monitor <span className="osap-highlight">OSAP</span>’s website for updates on application windows and deadlines.
                </p>
            </div>
        </section>
    );
}

export default WhatIsOsap;